import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.822 14.49l-2.118 2.117a3.005 3.005 0 0 0 .007 4.25l7.058 7.057a2.998 2.998 0 0 0 4.249.007l2.118-2.118a2.002 2.002 0 0 1 2.833-.002l7.775 7.775a3 3 0 0 1-.005 4.25l-4.24 4.24c-2.731 2.732-7.69 3.45-11.006 1.466 0 0-5.312-2.235-13.688-10.612C6.428 24.544 4.11 19.133 4.11 19.133 2.179 15.785 2.834 10.85 5.558 8.125l4.24-4.24a3 3 0 0 1 4.251-.004l7.775 7.774a2.001 2.001 0 0 1-.002 2.834zM8.387 10.953c-1.447 1.447-1.692 4.342-.812 6.18 0 0 1.413 2.564 2.052 3.507 1.89 2.79 4.52 5.964 8.006 9.451 3.486 3.486 6.642 6.098 9.398 7.962.93.629 3.516 2.046 3.516 2.046 1.674.876 4.651.611 6.124-.862l3.54-3.54-5.658-5.656-.707.707a6.998 6.998 0 0 1-9.906-.007l-7.058-7.057c-2.735-2.735-2.741-7.171-.007-9.906l.708-.708-5.657-5.657-3.54 3.54z" fill={color} fillRule="nonzero"/>
    </svg>
)

export default class IconPhone extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
